import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54701e66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "container" }

import { authInfo } from "@/core/auth";
import i18n from "@/core/i18n/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const { t } = i18n.global;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, [
        _createElementVNode("strong", null, _toDisplayString(_unref(t)("Auth.ProfileOf")) + " " + _toDisplayString(_unref(authInfo).value.username), 1)
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(_unref(t)("User.UserName")) + ":", 1),
        _createTextVNode(" " + _toDisplayString(_unref(authInfo).value.username), 1)
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(_unref(t)("Auth.AccessToken")) + ":", 1),
        _createTextVNode(" " + _toDisplayString(_unref(authInfo).value.accessToken), 1)
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(_unref(t)("Auth.RefreshToken")) + ":", 1),
        _createTextVNode(" " + _toDisplayString(_unref(authInfo).value.refreshToken), 1)
      ])
    ])
  ]))
}
}

})